import { Text } from "@fluentui/react";
import React from "react";
import { useIntl } from "react-intl";
import { IDatasetWidget } from "../../api/schema.api";
import ajax from "@cayo/shared/libs/ajax";
//import { isMedium } from "../../services/nav/nav-hooks";
import { LoadingOverlay, chartMessages } from "cayo.ui";
import Widget from "./Widget";
import { AbsoluteEmptyContainer, FullHeightColumn } from "./common";
import useWidgetSignals from "./dataset-signals.hook";

const DatasetWidget = (props: IDatasetWidget) => {
  const intl = useIntl();
  const { data, isLoading, error, reloadData } = ajax.useGet(props.url, props);

  useWidgetSignals({
    signal: "refresh",
    handler: reloadData,
  });

  if (isLoading) {
    return <LoadingOverlay />;
  }

  if (error) {
    return (
      <FullHeightColumn>
        <AbsoluteEmptyContainer>
          {error && (
            <>
              <Text styles={{ root: { fontWeight: "bold" } }}>
                {intl.formatMessage(chartMessages.loadDataError)}
              </Text>
              <Text variant="small">{error}</Text>
            </>
          )}
        </AbsoluteEmptyContainer>
      </FullHeightColumn>
    );
  }

  return <Widget {...props} data={data} onRefresh={reloadData} />;
};

export default DatasetWidget;
